import * as React from 'react'

import PageView from 'syft-acp-core/components/PageView'
import BanReviewDetail from 'syft-acp-core/entities/BanReviewDetail'

import ConductSubNav from './ConductSubNav'
import { RouteComponentProps } from 'react-router-dom'

export const BanReviewsView = ({ match: { params } }: RouteComponentProps<{ id: string }>) => (
  <>
    <ConductSubNav />
    <PageView title={[`Conduct review ${params.id}`]}>
      <BanReviewDetail id={Number(params.id)} />
    </PageView>
  </>
)
